var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("General Notes")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.additional_general_notes || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Special Instructions")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.additional_special_instructions || "N/A"))]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Other Notes")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [_vm._v(_vm._s(_vm.data.additional_other_information || "N/A"))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Additional Notes"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }